import React, {useMemo} from "react";
import "./index.scss";
import {object} from "prop-types";
import {Icon} from "features/components/icon";
import Text from "features/components/text";
import {ISO_8601} from "moment";
import moment from "moment";
import {__} from "services/i18n";
import {historyObject} from "historyObject";

export const NotificationItem = (props) => {
    const {notification} = props;
    const {created_at, type, resource, text, unread, id, extra} = notification;
    const icon = useMemo(() => {
        const icons = {
            "comment.event": "comment-text",
            "comment.video": "comment-text",
            "comment.thread": "comment-text",
            "tag.event": "at",
            "tag.video": "at",
            "tag.directory": "at",
            "content.event": "calendar",
            "content.video": "comment-video",
            "content.directory": "comment-video",
            "recommendation.user": "thumbs-up",
            "recommendation_request.user": "thumbs-up",
            "skill_confirmation.user": "check",
            "skill_confirmation_company.user": "check"
        };
        return icons[`${type}.${resource}`];
    }, [type, resource]);

    const date = useMemo(() => {
        const rawDate = moment(created_at, ISO_8601);
        const hours = rawDate.format("HH:mm");
        if(rawDate.isSame(moment(), "day")) {
            return __("notifications.item.today", [{key: "[hours]", value: hours}]);
        }
        if(rawDate.isSame(moment().subtract(1, "day"), "day")) {
            return __("notifications.item.yesterday", [{key: "[hours]", value: hours}]);
        }
        return rawDate.format("DD/MM/YYYY HH:mm");
    }, [created_at]);

    const title = useMemo(() => {
        const titles = {
            "comment.event": "comment-event",
            "comment.video": "comment-video",
            "comment.thread": "comment-thread",
            "tag.event": "tag",
            "tag.video": "tag",
            "tag.directory": "tag",
            "content.event": "event",
            "content.video": "content",
            "content.directory": "content",
            "recommendation.user": "recommendation",
            "recommendation_request.user": "recommendation_request",
            "skill_confirmation.user": "check",
            "skill_confirmation_company.user": "check"
        };
        return __("notifications.item.titles."+titles[`${type}.${resource}`], [{key: "[text]", value: text}, {key: "[skill]", value: extra.skill_name || ""}, {key: "[company]", value: extra.company_name || ""}]);
    }, [text, type, resource, extra]);

    const link = useMemo(() => {
        let resource_type = resource;
        if (resource === "thread") {
            resource_type = "threads";
        }
        if(resource === "user") {
            if(extra.company_id) {
                return `/people/${id}/company/${extra.company_id}`
            }
            return `/people/${id}`
        }
        return `/${resource_type}/${id}`;
    }, [resource, id, extra]);

    return <div className="notification-item" onClick={() => {historyObject.push(link)}}>
        <div className={`type ${unread ? "unread" : ""}`}>
            <Icon>{icon}</Icon>
        </div>
        <div className={"data"}>
            <Text size={16} alt={title}>{title}</Text>
            <Text size={14}>{date}</Text>
        </div>
    </div>
}
NotificationItem.propTypes = {
    notification: object.isRequired
}